import React from "react";
import { DropzoneState } from "react-dropzone";
import { useFormContext } from "react-hook-form";

export const FileUploadForm = ({ dropzone, isLoading = false } : Readonly<{ dropzone: DropzoneState, isLoading: boolean }>) => {
    const { watch } = useFormContext();
    const fileData = watch('fileData');

    if (isLoading || fileData) {
        return null;
    }

    const { getRootProps, getInputProps } = dropzone;
    return (
        <div {...getRootProps({ className: 'dropzone d-flex px-3 py-2 border border-3 border-opacity-10' })}>
            <input {...getInputProps()} />
            <div className="d-flex flex-fill justify-content-center align-items-center py-4">
                <p className="m-0">Drag 'n' drop some files here, or click to select files</p>
            </div>
        </div>
    );
};